import { library } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/free-regular-svg-icons';
import {
  faArrowDown,
  faArrowLeft,
  faCheckToSlot,
  faChevronDown,
  faChevronRight,
  faCircle,
  faClipboardCheck,
  faCopy,
  faMagnifyingGlass,
  faReceipt,
  faRotate,
  faSliders,
  faStar,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { faLock as faSolidLock } from '@fortawesome/free-solid-svg-icons/faLock';
import {
  faNfcSymbol as fadNfcSymbol,
  faPenField as fadPenField,
  faWarehouseFull as fadWarehouseFull,
  faRightLeft,
  faTrashCheck,
} from '@fortawesome/pro-duotone-svg-icons';
import {
  faBars,
  faCalendarDays,
  faCommentLines,
  faEllipsis,
  faFileCheck,
  faFileCircleCheck,
  faLock,
  faPenToSquare,
  faArrowDownWideShort as farArrowDownWideShort,
  faArrowUpTriangleSquare as farArrowUpTriangleSquare,
  faArrowUpWideShort as farArrowUpWideShort,
  faCheck as farCheck,
  faCheckDouble as farCheckDouble,
  faChevronLeft as farChevronLeft,
  faCircleExclamationCheck as farCircleExclamationCheck,
  faDash as farDash,
  faDownLeftAndUpRightToCenter as farDownLeftAndUpRightToCenter,
  faEye as farEye,
  faMinus as farMinus,
  faPen as farPen,
  faPlus as farPlus,
  faToolbox as farToolbox,
  faTrashCheck as farTrashCheck,
  faUndo as farUndo,
  faUpRightAndDownLeftFromCenter as farUpRightAndDownLeftFromCenter,
  faWarehouseFull as farWarehouseFull,
  faScrewdriverWrench,
  faTrashCan,
  faXmark,
  faXmarkLarge,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowTurnRight,
  faArrowUpSmallBig,
  faBars as faBarsSolid,
  faBoxOpenFull,
  faCartShopping,
  faCheck,
  faCommentLines as faCommentLinesSolid,
  faDiamondExclamation,
  faDollyEmpty,
  faExclamationTriangle,
  faFolderMagnifyingGlass,
  faHistory,
  faLockOpen,
  faMinus,
  faPlus,
  faSearch,
  faThumbsUp as fasThumbsUp,
  faThumbtack,
  faTimes,
  faWarehouseFull,
} from '@fortawesome/pro-solid-svg-icons';

/* Create a library of icons from the 4 sets of free and pro sets so they can be refered
 * as string names in the Icon component of RN-GDS
 * Check FontAwesome.com and your designs for which icon to include as needed
 * IMPORTANT NOTE: Whenever you add a new icon to the library. Reload the whole app as hot refresh will not work.
 */
library.add(
  faStar,
  faSliders,
  faChevronRight,
  faLock,
  faSolidLock,
  faBoxOpenFull,
  faCheckToSlot,
  faMagnifyingGlass,
  faChevronDown,
  faScrewdriverWrench,
  faXmark,
  faChevronRight,
  faSearch,
  faPenToSquare,
  far,
  faPlus,
  faTimes,
  faTrashCan,
  faCheck,
  faMinus,
  faCartShopping,
  faCommentLines,
  faCalendarDays,
  faCommentLinesSolid,
  faWarehouseFull,
  faBars,
  faBarsSolid,
  faPlus,
  faUser,
  faClipboardCheck,
  faCopy,
  faArrowDown,
  faArrowLeft,
  faCircle,
  faDollyEmpty,
  faReceipt,
  faXmarkLarge,
  faEllipsis,
  farChevronLeft,
  farCheck,
  farMinus,
  faLockOpen,
  faHistory,
  farWarehouseFull,
  fadWarehouseFull,
  faArrowUpSmallBig,
  faThumbtack,
  farArrowDownWideShort,
  faRightLeft,
  farPlus,
  farCheckDouble,
  farTrashCheck,
  faTrashCheck,
  farUndo,
  farPen,
  farToolbox,
  faFolderMagnifyingGlass,
  farUpRightAndDownLeftFromCenter,
  farDownLeftAndUpRightToCenter,
  farEye,
  farCircleExclamationCheck,
  faRotate,
  faDiamondExclamation,
  faExclamationTriangle,
  farArrowUpWideShort,
  faArrowTurnRight,
  farArrowUpTriangleSquare,
  farDash,
  faFileCircleCheck,
  faFileCheck,
  fadPenField,
  fadNfcSymbol,
  fasThumbsUp
);
